const TONO_FILA = {
  ERROR: "text-red-700", OMITIDA: "text-slate-500", VINCULADO: "text-sky-700",
  ADVERTENCIA: "text-amber-700", NUEVO: "text-emerald-700",
};

const tono = (txt) => TONO_FILA[String(txt || "").split(":")[0]] || "text-slate-700";

export function TablaFilas({ filas }) {
  return (
    <div className="max-h-96 overflow-auto rounded-md border border-slate-200" data-testid="migracion-tabla-filas">
      <table className="w-full min-w-[720px] text-sm">
        <thead className="sticky top-0 bg-slate-50 text-left text-[11px] uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-3 py-2">Fila</th>
            <th className="px-3 py-2">Nombre</th>
            <th className="px-3 py-2">RFC / CURP</th>
            <th className="px-3 py-2">Resultado</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {filas.map((f) => (
            <tr key={f.fila} data-testid={`migracion-fila-${f.fila}`}>
              <td className="px-3 py-2 font-mono text-xs text-slate-500">{f.fila}</td>
              <td className="px-3 py-2 text-slate-800">{f.nombre || "—"}</td>
              <td className="px-3 py-2 font-mono text-xs text-slate-600">{f.rfc || f.curp || "—"}</td>
              <td className={`px-3 py-2 text-xs ${tono(f.resultado_texto)}`} data-testid={`migracion-fila-${f.fila}-resultado`}>
                {f.resultado_texto}
                {f.estado === "procesada" && f.diferencias?.length > 0 && (
                  <span className="ml-1 text-slate-400">· {f.diferencias.length} dato(s) distinto(s) en el Excel, no se cambiaron</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
